import React, { useState } from "react";

export default function WorkspaceInsightDetail({
    insight,
	onEvidenceRequested
})
{
    const images =
    [
        "/assetimages/transformer1.jpg",
        "/assetimages/transformer2.jpg",
        "/assetimages/transformer3.jpg",
        "/assetimages/transformer4.jpg"
    ];

    const snippets =
    [
        {
            title: "Fire Risk Assessment.pdf",
            page: 17,
            text:
                "Fire doors serving escape routes shall remain unobstructed at all times."
        },
        {
            title: "Weekly Inspection.xlsx",
            page: 4,
            text:
                "Fire Door FD-17 failed operational inspection due to damaged closer."
        },
        {
            title: "Maintenance Report.pdf",
            page: 9,
            text:
                "Replacement of closer recommended within 14 days."
        },
        {
            title: "Building Compliance Audit.pdf",
            page: 31,
            text:
                "Inspection identified multiple blocked escape routes."
        }
    ];

    const [selectedImage,
        setSelectedImage] =
        useState(
            images[0]);

    const severityColour =
        insight?.severity === "CRITICAL"
            ? "#ef4444"
        : insight?.severity === "MEDIUM"
            ? "#f59e0b"
        : "#22c55e";
		
		const severityStyle =
		    insight?.severity === "CRITICAL"
		        ?
		        {
		            background:
		                "linear-gradient(180deg,#ef4444,#b91c1c)",

		            boxShadow:
		                "0 5px 14px rgba(239,68,68,.35)"
		        }
		    : insight?.severity === "MEDIUM"
		        ?
		        {
		            background:
		                "linear-gradient(180deg,#fbbf24,#d97706)",

		            boxShadow:
		                "0 5px 14px rgba(245,158,11,.35)"
		        }
		    :
		        {
		            background:
		                "linear-gradient(180deg,#34d399,#16a34a)",

		            boxShadow:
		                "0 5px 14px rgba(34,197,94,.35)"
		        };

    return (

        <div
            style={{
                height: "100%",

                overflowY: "hidden",

				background: "#f7f8fa",

				color: "#1f2937",

                padding: "22px"
            }}
        >

		{/*==================================================
		    IMAGE GALLERY
		==================================================*/}

		<div
		    style={{
		        display: "flex",

		        gap: "10px",

		        marginBottom: "20px"
		    }}
		>

		    {/* MAIN IMAGE */}

		    <div
		        style={{
		            flex: 1,

		            height: "170px",

		            borderRadius: "14px",

		            overflow: "hidden",

					boxShadow:
					    "0 8px 20px rgba(0,0,0,.16)"
		        }}
		    >

		        <img

		            src={selectedImage}

		            alt=""

		            style={{
		                width: "100%",

		                height: "100%",

		                objectFit: "cover",

		                display: "block"
		            }}

		        />

		    </div>


		    {/* THUMBNAILS */}

		    <div
		        style={{
		            width: "72px",

		            display: "flex",

		            flexDirection: "column",

		            gap: "8px"
		        }}
		    >

		        {
		            images.map(
		                image =>
		                (
		                    <img

		                        key={image}

		                        src={image}

		                        alt=""

		                        onClick={() =>
		                            setSelectedImage(
		                                image)}

		                        style={{

		                            width: "72px",

		                            height:
		                                selectedImage === image
		                                    ? "52px"
		                                    : "34px",

		                            objectFit: "cover",

		                            borderRadius: "9px",

		                            cursor: "pointer",

		                            border:

		                                selectedImage === image

		                                    ? "2px solid #5a9bd6"

		                                    : "2px solid #d8dde6",

		                            transition:
		                                ".18s"
		                        }}

		                    />
		                ))
		        }

		    </div>

		</div>

            {/* TITLE */}

            <div
                style={{
                    fontSize: "22px",

                    fontWeight: 700,

                    marginBottom: "8px"
                }}
            >
                {
                    insight?.title ??
                    "Fire Door Inspection Overdue"
                }
            </div>

			<div
			    style={{
			        display: "inline-flex",

			        alignItems: "center",

			        justifyContent: "center",

			        padding: "8px 18px",

			        borderRadius: "999px",

			        color: "white",

			        fontWeight: 700,

			        fontSize: "12px",

			        marginBottom: "18px",

			        ...severityStyle
			    }}
			>
			    {insight?.severity ?? "CRITICAL"}
			</div>

            {/* LOCATION */}

            <div
                style={{
                    color: "#4b5563",

                    fontSize: "13px",

                    lineHeight: "24px",

                    marginBottom: "20px"
                }}
            >
                <div>
                    <strong>Building:</strong> Broadcasting House
                </div>

                <div>
                    <strong>Location:</strong> Level 03 • West Corridor
                </div>

                <div>
                    <strong>Confidence:</strong> 97%
                </div>

            </div>

			{/*==================================================
			    INVESTIGATION SUMMARY
			==================================================*/}

			<div
			    style={{
			        background: "#ffffff",

			        border: "1px solid #e5e7eb",

			        borderRadius: "16px",

			        padding: "18px",

			        marginBottom: "24px",

			        boxShadow:
			            "0 6px 18px rgba(0,0,0,.06)"
			    }}
			>

			    <div
			        style={{
			            fontSize: "17px",

			            fontWeight: 700,

			            color: "#1f2937",

			            marginBottom: "12px"
			        }}
			    >
			        Investigation Summary
			    </div>

			    <div
			        style={{
			            color: "#4b5563",

			            lineHeight: "26px",

			            fontSize: "14px"
			        }}
			    >
			        Fire door FD-17 appears to have failed inspection due to
			        a damaged self-closing mechanism. The doorway also appears
			        partially obstructed by stored materials which may affect
			        the protected escape route. Immediate inspection and
			        remedial action is recommended.
			    </div>

			</div>

         

			<div
			    style={{
			        display: "flex",

			        gap: "12px",

			        marginBottom: "24px",

			        padding: "14px",

			        background: "#ffffff",

			        border: "1px solid #e5e7eb",

			        borderRadius: "16px",

			        boxShadow:
			            "0 6px 18px rgba(0,0,0,.05)"
			    }}
			>

			    {/*==================================================
			        LOCATE
			    ==================================================*/}

			    <button

			        style={{

			            flex: 1,

			            height: "42px",

			            border: "none",

			            borderRadius: "10px",

			            background:
			                "linear-gradient(180deg,#5a9bd6,#356ea1)",

			            color: "white",

			            fontWeight: 600,

			            fontSize: "13px",

			            cursor: "pointer",

			            boxShadow:
			                "0 5px 14px rgba(53,110,161,.30)"
			        }}

			    >
			        📍 Locate in Scan
			    </button>


			    {/*==================================================
			        EVIDENCE
			    ==================================================*/}

			    <button
				onClick={() =>
				   {
				       if (onEvidenceRequested)
				       {
				           onEvidenceRequested(
				               insight);
				       }
				   }}
			        style={{

			            flex: 1,

			            height: "42px",

			            borderRadius: "10px",

			            border:
			                "1px solid #d9dee7",

			            background:
			                "#ffffff",

			            color:
			                "#374151",

			            fontWeight: 600,

			            fontSize: "13px",

			            cursor: "pointer"
			        }}

			    >
			        📄 Evidence
			    </button>

			</div>
          

        </div>

    );

}